export default {
	fees: (state) => {
		const lang = state.language;

		const feeConfig = {
			"fr-FR": [
				{
					name: "fileFees",
					value: 19,
				},
			],
			"nl-NL": [
				{
					name: "fileFees",
					value: 19,
				},
				{
					name: "NL_Calamiteitenfonds",
					value:
						state.participants.length < 10
							? 2.5
							: state.participants.length < 19
							? 5
							: 7.5,
				},
				{
					name: "NL_SGRcontribution",
					value: 5 * state.participants.filter((age) => age > 1).length,
				},
			],
			"en-US": [
				{
					name: "fileFees",
					value: 19,
				},
			],
		};

		return feeConfig[lang];
	},
};
